<template>
    <div id="all-reviews">
        <div class="review-wrapper">
            <div class="review-inner-wrapper">
                <p class="review-title">Sweet, safe, hospitable!</p>
                <p class="review-content">
                    "I cannot say enough positive things about this
                    obviously well kept, clean, reasonable hotel..."
                </p>
                <p class="review-source">
                    TripAdvisor
                </p>
            </div>
            <img src="../assets/images/review-profiles/terrysherman.jpg"
                 alt="profile picture" class="profile-pic">
        </div>

        <div class="review-wrapper">
            <div class="review-inner-wrapper">
                <p class="review-title">Enjoying and comfortable hotel</p>
                <p class="review-content">
                    "The hotel Las Hamacas is a great place to stay..."
                </p>
                <p class="review-source">
                    TripAdvisor
                </p>
            </div>
            <img src="../assets/images/review-profiles/carlo-t.jpg"
                 alt="profile picture" class="profile-pic">
        </div>

        <div class="review-wrapper">
            <div class="review-inner-wrapper">
                <p class="review-title">Excelente lugar</p>
                <p class="review-content">
                    "Un bonito hotel a la orilla de la carretera con
                    todos los servicios que el viajante de hoy
                    en día espera..."
                </p>
                <p class="review-source">
                    TripAdvisor
                </p>
            </div>
            <img src="../assets/images/review-profiles/gabriel-a.jpg"
                 alt="profile picture" class="profile-pic">
        </div>
    </div>
</template>

<script>
    export default {
        name: "Review"
    }
</script>

<style scoped>
    #all-reviews {
        display: flex;
        margin-top: 40px;
        justify-content: space-between;
    }
    .review-wrapper {
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .review-wrapper .profile-pic {
        width: 60px;
        border-radius: 50%;
    }

    .review-wrapper .review-inner-wrapper {
        display: flex;
        max-width: 350px;
        height: 160px;
        flex-direction: column;
        align-items: center;
        justify-content: space-between;
        border-bottom: 1px solid #999;
        margin-bottom: 15px;
        padding: 10px;
    }

    .review-inner-wrapper .review-title {
        font-size: 1.4rem;
        margin: 0;
        font-weight: 600;
        text-align: center;
    }
    .review-inner-wrapper .review-content {
        font-size: 1.2rem;
        margin: 0;
        text-align: center;
        font-style: italic;
    }
    .review-inner-wrapper .review-source {
        font-size: 1.1rem;
        margin: 10px 0;
        font-weight: 600;
    }

    @media only screen and (min-width: 320px) and (max-width: 767px) {
        #all-reviews {
            flex-direction: column;
        }
        .review-wrapper .review-inner-wrapper {

        }
    }
</style>